import { useContext } from "react";
import { Form } from "react-bootstrap";
import { LanguageContext } from "providers/LanguageContext";

const languages = [
    { value: "pr", label: "Portuguese" },
    { value: "en", label: "English" }
];

const LanguageSelect = () => {
    const { language, changeLanguage } = useContext(LanguageContext);

    function handleLanguageChange(e) {
        changeLanguage(e.target.value);
    }

    return (
        <Form.Control
            as="select"
            name="year"
            className="language-select"
            onChange={handleLanguageChange}
            value={language}
        >
            {languages.map(lang => (
                <option value={lang.value}>{lang.label}</option>
            ))}
        </Form.Control>
    );
};

export default LanguageSelect;
